/**
 * Project the shell's open-panel state into the snapshot shape exposed to the
 * agent via the get_view_state UI tool. Drops the heavy `config` object and
 * keeps only id + resolved props per panel.
 */
import type { OpenPanel, PanelId, ViewState } from '@/types/panels';

interface ShellState {
    openPanels?: OpenPanel[];
    focusedId?: PanelId | null;
}

export function projectViewState({ openPanels, focusedId }: ShellState): ViewState {
    return {
        focusedId: focusedId ?? null,
        openPanels: (openPanels ?? []).map((p) => ({ id: p.id, props: p.props ?? {} })),
    };
}
